import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ButtonSecondary({ text, icon = '', action, onClick }) {
    const handleClick = () => {
        if (onClick) {
            onClick(action);
        }
    };

    return (
        <button onClick={handleClick} className="bg-white border-2 border-solid border-main text-main py-2 px-4 transition-all duration-300 ease-in-out hover:bg-main hover:text-white">
            {text}
            {icon && <FontAwesomeIcon icon={icon} className="ml-2" />}
        </button>
    );
}
